module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og sørsamisk_primærlogo_neg(hvit).a166db8d.png";